// extracted by mini-css-extract-plugin
export default {"contractBox":"pdf-viewer_contractBox__j+-Qe"};